import React from "react";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { usePaymentForm } from "../../PaymentFormContext";

export default function useRecurringPaymentState() {
  const {
    state: {
      recurringPayment: {
        recurring,
        frequency, // "weekly", "monthly", "quarterly", "annually"
        startDate,
        endDate,
        editing,
      },
      paymentParent,
    },
    dispatch,
  } = usePaymentPage();
  const {
    state: {
      formStages: {
        amount, // untouched, expanded, complete
        auth, // untouched, requestCode, verifyCode, skipped, isFullyLoggedIn
        paymentInfo, // untouched, chooseAddMethodType, addCard, methodSelected}
      },
      dispatch: formDispatch,
    },
  } = usePaymentForm();

  const recurringAlwaysOn = paymentParent?.recurringAlwaysOn;

  /**
   * FINISH THIS HOOK
   */

  const [settings, setSettings] = React.useState({
    expanded: false,
    fullSize: true,
  });
  // React.useEffect(() => {
  //   console.log({
  //     recurring,
  //     editing,
  //     paymentInfo,
  //     amount,
  //     auth,
  //     ...settings,
  //   });
  // }, [paymentInfo, recurring, editing, amount, auth, settings]);

  React.useEffect(() => {
    let updatedSettings = {
      expanded: false,
      fullSize: true,
    };

    if ((recurring && editing) || (recurringAlwaysOn && editing)) {
      updatedSettings.expanded = true;
    } else {
      updatedSettings.fullSize = false;
    }

    if (amount === "expanded") {
      updatedSettings.fullSize = true;
    }

    setSettings(updatedSettings);
  }, [recurring, amount, editing, recurringAlwaysOn]);

  return settings;
}
